export default __webpack_public_path__ + "static/02-0b699e5c42fffb5f4441b273780b01ee.jpg";